/*
 * Fetch every page of a paginated list endpoint and return the flat array.
 * Used to build id→name maps (customers/suppliers) so lists never fall back to
 * "#id" labels. `key` is the array property in the response (e.g. 'customers').
 */
export async function fetchAllPaginated(api, path, key, perPage = 100) {
  const out = []
  let page = 1
  // Guard against runaway loops; real datasets are small.
  for (let i = 0; i < 50; i += 1) {
    // eslint-disable-next-line no-await-in-loop
    const { data } = await api.get(path, { params: { page, per_page: perPage } })
    const items = data?.[key] || []
    out.push(...items)
    const pages = data?.pagination?.pages || 1
    if (page >= pages || items.length === 0) break
    page += 1
  }
  return out
}

/* Build a Map<id, item> from a list. */
export function indexById(items) {
  return new Map((items || []).map((it) => [it.id, it]))
}
